@if (!lists) {
  <div class="loading-items">
    <mat-spinner style="margin: 0 auto;"></mat-spinner>
  </div>
}
@if (lists) {
  <div>
    <div class="error">{{errorString}}</div>
    <span>
      <mat-form-field>
        <input matInput placeholder="New List" [(ngModel)]="_newListString" (input)="validate()" ng-pattern="/^[a-zA-Z0-9]*$/" id="list-editor-add-list"/>
      </mat-form-field>
    </span>
  </div>
}